import * as React from 'react';
import { Container, TituloSecao } from './styles';
import Grid from '../../componentes/Grid';
import { useParams } from 'react-router-dom';
import userContext from '../../Context/UserContext';
import { useContext } from 'react';

const Vitrine: React.FC = () => {
  const { id, name }: any = useParams();
  const currentlyUser = useContext(userContext);
  const { Codcliente, Codempresacli } = currentlyUser.user;
  return (
    <Container>
      <TituloSecao>
        Vitrine - {name}
      </TituloSecao>
      <Grid Titulo={'Vitrine' + id} Vitrine={id} Codcliente={Codcliente} Codempresacli={Codempresacli} />
    </Container>
  )
};

export default Vitrine;
